// dolny rząd mobilnego headera (Wise) - fioletowy przycisk Kategorie

import React, { useRef, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, PlusCircle, DashCircle } from 'react-bootstrap-icons';
import classnames from 'classnames';
import { Grid } from '@mui/material';

import { useGetLayoutCategories } from 'api';
import { ICategoryListItem } from 'api/types';
import { useClickOutside } from 'hooks';
import { Link, Loader } from 'components/controls';

import styles from 'theme/components/wise/WiseHeaderBottomBar/WiseHeaderBottomBar.module.scss';

const WiseHeaderBottomBar = () => {
  const { t } = useTranslation();

  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const popupContentRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);

  useClickOutside([popupContentRef, triggerRef], () => setIsPopupOpened(false));

  const [expandedCategoryIds, setExpandedCategoryIds] = useState<number[]>([]);

  const { data: categoriesData, isLoading: isCategoriesLoading } = useGetLayoutCategories({
    page: 1,
    limit: 999,
    search_keyword: ''
  });

  const renderCategoryTree = useCallback(
    (category: ICategoryListItem) => {
      const renderTree = (categories: ICategoryListItem[] = [], level = 0) =>
        categories.map((cat) => (
          <div
            key={cat.id}
            className={classnames(styles.category, { [styles.main]: level === 0 })}>
            {cat.subcategories_total_count > 0 && (
              <>
                {expandedCategoryIds.includes(cat.id) ||
                cat.subcategories.some((item) => item.id === undefined) ? (
                  <DashCircle
                    onClick={() =>
                      setExpandedCategoryIds((prev) =>
                        prev.filter((categoryId) => categoryId !== cat.id)
                      )
                    }
                  />
                ) : (
                  <PlusCircle
                    onClick={() => setExpandedCategoryIds((prev) => [...prev, cat.id])}
                  />
                )}
              </>
            )}
            <Link
              to={`/${cat.url_link}`}
              onClick={() => setIsPopupOpened(false)}
              className={classnames({ [styles.chosen]: cat.id === undefined })}>
              {cat.name} <span className={styles.counter}>({cat.products_count})</span>
            </Link>

            {cat.subcategories_total_count > 0 &&
              (expandedCategoryIds.includes(cat.id) ||
                cat.subcategories.some((item) => item.id === undefined)) &&
              renderTree(cat.subcategories, level + 1)}
          </div>
        ));

      return renderTree([category]);
    },
    [expandedCategoryIds]
  );

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Wise-WiseHeaderBottomBar'
      )}>
      <div ref={triggerRef} className={styles.triggerWrapper}>
        <button
          type="button"
          className={classnames(styles.categoriesButton, {
            [styles.open]: isPopupOpened
          })}
          onClick={() => setIsPopupOpened((s) => !s)}>
          <span>{t('Kategorie')}</span>
          <ChevronDown
            className={classnames(styles.chevron, { [styles.chevronOpen]: isPopupOpened })}
          />
        </button>
      </div>

      {isPopupOpened && (
        <div className={styles.categoriesPopup}>
          <div className={styles.content} ref={popupContentRef}>
            {isCategoriesLoading && <Loader />}
            <Grid container>
              {categoriesData?.items.map((category, index) => (
                <React.Fragment key={category.url_link ?? index}>
                  {category.categories_list &&
                    category.show_category_button &&
                    category.categories_list.map((subCategory) => (
                      <Grid item key={subCategory.id ?? subCategory.url_link} xs={12}>
                        {renderCategoryTree(subCategory)}
                      </Grid>
                    ))}
                </React.Fragment>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </div>
  );
};

export default WiseHeaderBottomBar;
